module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allItems":"All {items}","editItem":"Edit {item}"},"de":{"allItems":"Alle {items}","editItem":"{item} Bearbeiten"},"fr":{"allItems":"Tous {items}","editItem":"{item} Editer"},"it":{"allItems":"Tutti {items}","editItem":"Modificare {item}"}}')
  delete Component.options._Ctor
}
